import {call, takeEvery} from 'redux-saga/effects'

import * as userInteractionsActions from '../actions/userInteractions'
import {addGlobalHtmlClass, removeGlobalHtmlClass} from '../utils'

const hiddenClass = 'u-zendesk-hidden'

export function* hideZendeskWorker() {
  yield call(addGlobalHtmlClass, hiddenClass)
}

export function* hideZendeskSaga() {
  yield takeEvery(userInteractionsActions.HIDE_ZENDESK, hideZendeskWorker)
}

export function* showZendeskWorker() {
  yield call(removeGlobalHtmlClass, hiddenClass)
}

export function* showZendeskSaga() {
  yield takeEvery(userInteractionsActions.SHOW_ZENDESK, showZendeskWorker)
}
